import React, { useRef } from "react";
import classNames from "classnames";
import { PopoverBody, UncontrolledPopover } from "reactstrap";
import { IconDefinition } from "../Icon/Icon.generated";
import { Icon } from "../Icon/Icon";

import "./Tag.scss";

interface Props {
  title: string;
  icon: IconDefinition;
  className?: string;
  information?: string;
}

export const Tag = ({ title, icon, className, information }: Props) => {
  const uniqueIdRef = useRef(
    `TagPopover-${Math.random().toString(36).substr(2, 9)}`
  );
  const content = (
    <>
      <Icon icon={icon} />
      <span>{title}</span>
    </>
  );

  if (!information) {
    return <div className={classNames("Tag", className)}>{content}</div>;
  }

  return (
    <>
      <button
        type="button"
        id={uniqueIdRef.current}
        className={classNames("Tag", "Tag--informational", className)}
        aria-label={`${title}: more information`}
      >
        {content}
      </button>
      <UncontrolledPopover
        trigger="legacy"
        placement="bottom"
        target={uniqueIdRef.current}
        className="InformationBox__popover"
        container="body"
        fade={false}
      >
        <PopoverBody className="InformationBox__content">
          <div dangerouslySetInnerHTML={{ __html: information }} />
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
};
